class Logger {
  constructor() {
    this.config = {
      enabled: process.env.REACT_APP_ENV != 'uat',
      // includeCaller: process.env.NODE_ENV !== 'development',
    };

    // In development, pass through directly to native console methods so
    // DevTools shows the caller's file/line instead of this wrapper.
    if (process.env.NODE_ENV === 'development') {
      this.debug = console.debug.bind(console);
      this.log = console.log.bind(console);
      this.info = console.info.bind(console);
      this.warn = console.warn.bind(console);
      this.error = console.error.bind(console);
    }
  }

  getCallerInfo() {
    const error = new Error();
    const stack = error.stack?.split('\n')[3]; // Skip Error, getCallerInfo, and log method
    const match = stack?.match(/at\s+(.+?)\s+\((.+?):(\d+):(\d+)\)/);
    if (!match) return { fileName: 'unknown', line: '0', fullPath: 'unknown' };
    const fullPath = match[2];
    const fileName =
      fullPath.split('/').pop() || fullPath.split('\\').pop() || 'unknown';
    return { fileName, line: match[3], fullPath };
  }

  formatMessage(level, message, args) {
    const timestamp = new Date().toISOString();
    const baseParts = [
      `[${timestamp}] [${level.toUpperCase()}]`,
      message,
      ...args,
    ];
    if (this.config.includeCaller) {
      const caller = this.getCallerInfo();
      return [...baseParts, '\n', `@ ${caller.fullPath}:${caller.line}`];
    }
    return baseParts;
  }

  configure(config) {
    this.config = { ...this.config, ...config };
  }

  debug(message, ...args) {
    if (this.config.enabled) {
      console.debug(...this.formatMessage('debug', message, args));
    }
  }

  log(message, ...args) {
    if (this.config.enabled) {
      console.log(...this.formatMessage('log', message, args));
    }
  }

  info(message, ...args) {
    if (this.config.enabled) {
      console.info(...this.formatMessage('info', message, args));
    }
  }

  warn(message, ...args) {
    if (this.config.enabled) {
      console.warn(...this.formatMessage('warn', message, args));
    }
  }

  error(message, ...args) {
    if (this.config.enabled) {
      if (message instanceof Error) {
        const formatted = this.formatMessage('error', message.message, []);
        console.error(...formatted);
        console.error(message); // Preserve original error stack
      } else {
        console.error(...this.formatMessage('error', message, args));
      }
    }
  }
}

// Create a singleton instance
export const logger = new Logger();

// Configure logger based on environment
logger.configure({
  enabled: process.env.REACT_APP_ENV != 'uat',
  includeCaller: process.env.NODE_ENV !== 'development' || true,
});
